(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue-prism-editor'), require('debounce'), require('vue2-dropzone'), require('vue2-dropzone/dist/vue2Dropzone.min.css')) :
    typeof define === 'function' && define.amd ? define(['exports', 'vue-prism-editor', 'debounce', 'vue2-dropzone', 'vue2-dropzone/dist/vue2Dropzone.min.css'], factory) :
    (global = global || self, factory(global.LbVueWysiwyg = {}, global.PrismEditor, global.debounce, global.Dropzone));
}(this, (function (exports, PrismEditor, debounce, Dropzone) { 'use strict';

    PrismEditor = PrismEditor && PrismEditor.hasOwnProperty('default') ? PrismEditor['default'] : PrismEditor;
    debounce = debounce && debounce.hasOwnProperty('default') ? debounce['default'] : debounce;
    Dropzone = Dropzone && Dropzone.hasOwnProperty('default') ? Dropzone['default'] : Dropzone;

    //
    //
    //
    //
    //
    //
    //
    //
    //


    var script = {
        props: ["module", "options"],
        data: function data()
        {
            return {
                showDashboard: false
            }
        },
        computed:
        {
            uid: function uid()
            {
                return this.$parent._uid
            }
        },
        methods:
        {
            closeDashboard: function closeDashboard()
            {
                this.showDashboard = false;
            },
            openDashboard: function openDashboard()
            {
                this.showDashboard = true;
            },
            exec: function exec()
            {
                this.$parent.exec.apply(null, arguments);
            },
            onBtnClick: function onBtnClick($event)
            {
                
                $event.preventDefault();

    			if(this.module.action !== undefined)
    			{
    				this.exec.apply(null, this.module.action);
    			}
                else if(this.module.render !== undefined)
                {
                    this.showDashboard = !this.showDashboard;
                    return;
                }
            }
        }
    };

    function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
    /* server only */
    , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
      if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
      } // Vue.extend constructor export interop.


      var options = typeof script === 'function' ? script.options : script; // render functions

      if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true; // functional template

        if (isFunctionalTemplate) {
          options.functional = true;
        }
      } // scopedId


      if (scopeId) {
        options._scopeId = scopeId;
      }

      var hook;

      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true

          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          } // inject component styles


          if (style) {
            style.call(this, createInjectorSSR(context));
          } // register component module identifier for async chunk inference


          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        }; // used by ssr in case component is cached and beforeCreate
        // never gets called


        options._ssrRegister = hook;
      } else if (style) {
        hook = shadowMode ? function () {
          style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
        } : function (context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook) {
        if (options.functional) {
          // register for functional component in vue file
          var originalRender = options.render;

          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return script;
    }

    var normalizeComponent_1 = normalizeComponent;

    /* script */
    var __vue_script__ = script;

    /* template */
    var __vue_render__ = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", [
        _c("a", {
          class: "vw-btn-" + _vm.module.title,
          domProps: { innerHTML: _vm._s(_vm.module.icon) },
          on: { click: _vm.onBtnClick }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showDashboard,
                expression: "showDashboard"
              }
            ],
            ref: "dashboard",
            staticClass: "dashboard"
          },
          [_vm.module.render ? _vm._m(0) : _vm._e()],
          1
        )
      ])
    };
    var __vue_staticRenderFns__ = [
      function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.module, {
          ref: "moduleDashboard",
          tag: "div",
          attrs: { uid: _vm.uid, options: _vm.options },
          on: { exec: _vm.exec }
        })
      }
    ];
    __vue_render__._withStripped = true;

      /* style */
      var __vue_inject_styles__ = undefined;
      /* scoped */
      var __vue_scope_id__ = undefined;
      /* module identifier */
      var __vue_module_identifier__ = undefined;
      /* functional template */
      var __vue_is_functional_template__ = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var Btn = normalizeComponent_1(
        { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
        __vue_inject_styles__,
        __vue_script__,
        __vue_scope_id__,
        __vue_is_functional_template__,
        __vue_module_identifier__,
        undefined,
        undefined
      );

    var bold = {
    	title: "bold",
    	action: ["bold"],
      description: "Bold",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/></svg>'
    };

    var italic = {
    	title: "italic",
      description: "Italic",
    	action: ["italic"],
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/></svg>'
    };

    var underline = {
    	title: "underline",
    	action: ["underline"],
      description: "Underline",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/></svg>'
    };

    //
    //
    //
    //
    //
    //
    //


    var script$1 = {
        title: "fontsize",
        description: "Font size (5px-50px)",
        icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><g><g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"><path d="M6551.1,2922.7c-48.6-120.3-1003.6-2601.3-1569.5-4078.6c-325.2-844.9-596.5-1551.6-601.7-1566.9c-10.2-25.6,105-33.3,524.9-33.3h537.7l64,174.1c33.3,94.7,163.9,453.2,286.8,798.8c125.5,345.6,238.1,642.7,250.9,660.6c17.9,23.1,258.6,30.7,1044.6,30.7h1019l35.8-69.1c20.5-40.9,166.4-414.7,325.2-832.1l291.9-763H9329h571l-115.2,276.5c-61.5,151.1-588.9,1438.9-1172.6,2859.9L7554.7,2966.3l-491.6,7.7C6574.1,2979.1,6574.1,2979.1,6551.1,2922.7z M7777.5-200.9c0-12.8-317.5-20.5-704.1-20.5c-386.6,0-704.1,5.1-704.1,12.8c0,5.1,135.7,378.9,304.7,824.4c166.4,448,309.8,844.9,320,883.3c58.9,253.5,46.1,279.1,427.6-734.8C7616.2,242.1,7777.5-190.6,7777.5-200.9z"/><path d="M1660.9,1360.9c-12.8-33.3-366.1-952.4-783.5-2043.1C457.6-1772.9,109.4-2686.9,101.7-2710c-10.2-43.5,17.9-46.1,330.3-46.1H775l217.6,609.4l217.6,606.8H2027h814.2l235.5-606.8l233-609.4h366.1c207.4,0,363.6,10.2,358.4,23c-2.5,12.8-386.6,952.5-852.6,2086.7l-844.9,2063.6h-327.7C1694.2,1417.3,1681.4,1414.7,1660.9,1360.9z M2080.8,495.6c35.8-110.1,448.1-1213.6,537.7-1438.9c17.9-43.5-20.5-46.1-586.3-46.1c-419.9,0-604.2,7.7-604.2,28.2c0,15.4,107.5,317.5,240.7,670.8c133.1,355.9,261.2,716.9,284.2,806.5c25.6,89.6,53.8,151.1,64,140.8C2027,646.6,2057.8,572.4,2080.8,495.6z"/></g></g></svg>',
        data: function data()
        {
            return {
                fontSize: 15
            }
        },
        created: function created()
        {
            var this$1 = this;

            this.$nextTick(function () {
                this$1.$refs.fontsize.focus();
            });
        },
        methods:
        {
            focus: function focus()
            {
                this.$refs.fontsize.focus();
            },
            setfont: function setfont(e)
            {
                this.$parent.closeDashboard();
                this.$emit("exec", "fontSize", this.fontSize+'px');
            }
        }
    };

    /* script */
    var __vue_script__$1 = script$1;

    /* template */
    var __vue_render__$1 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.fontSize,
              expression: "fontSize"
            }
          ],
          ref: "fontsize",
          attrs: { type: "number", min: "5" },
          domProps: { value: _vm.fontSize },
          on: {
            click: _vm.focus,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fontSize = $event.target.value;
            }
          }
        }),
        _vm._v(" "),
        _c("button", { attrs: { type: "button" }, on: { click: _vm.setfont } }, [
          _vm._v("Set")
        ])
      ])
    };
    var __vue_staticRenderFns__$1 = [];
    __vue_render__$1._withStripped = true;

      /* style */
      var __vue_inject_styles__$1 = undefined;
      /* scoped */
      var __vue_scope_id__$1 = undefined;
      /* module identifier */
      var __vue_module_identifier__$1 = undefined;
      /* functional template */
      var __vue_is_functional_template__$1 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var fontsize = normalizeComponent_1(
        { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
        __vue_inject_styles__$1,
        __vue_script__$1,
        __vue_scope_id__$1,
        __vue_is_functional_template__$1,
        __vue_module_identifier__$1,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //


    var script$2 = {
        title: "color",
        description: "Font color",
        icon: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 464.736 464.736" style="enable-background:new 0 0 464.736 464.736;" xml:space="preserve"><g><path d="M446.598,18.143c-24.183-24.184-63.393-24.191-87.592-0.008l-16.717,16.717c-8.98-8.979-23.525-8.979-32.504,0c-8.981,8.972-8.981,23.533,0,32.505l5.416,5.419L134.613,253.377h-0.016l-62.685,62.691c-4.982,4.982-7.919,11.646-8.235,18.684l-0.15,3.344c0,0.016,0,0.03,0,0.046l-2.529,56.704c-0.104,2.633,0.883,5.185,2.739,7.048c1.751,1.759,4.145,2.738,6.63,2.738c0.135,0,0.269,0,0.42-0.008l30.064-1.331h0.016l18.318-0.815l8.318-0.366c9.203-0.412,17.944-4.259,24.469-10.776l240.898-240.891l4.506,4.505c4.49,4.488,10.372,6.733,16.252,6.733c5.881,0,11.764-2.245,16.253-6.733c8.98-8.973,8.98-23.534,0-32.505l16.716-16.718C470.782,81.544,470.782,42.334,446.598,18.143z M272.639,227.33l-84.6,15.96l137.998-138.004l34.332,34.316L272.639,227.33z"/><path d="M64.5,423.872c-35.617,0-64.5,9.145-64.5,20.435c0,11.284,28.883,20.428,64.5,20.428s64.486-9.143,64.486-20.428C128.986,433.016,100.117,423.872,64.5,423.872z"/></g></svg>',
        data: function data()
        {
            return {
                color: '#000000'
            }
        },
        created: function created()
        {
            var this$1 = this;

            this.$nextTick(function () {
                this$1.$refs.color.focus();
            });
        },
        methods:
        {
            focus: function focus()
            {
                this.$refs.color.focus();
            },
            setcolor: function setcolor(e)
            {
                this.$parent.closeDashboard();
                this.$emit("exec", "foreColor", this.color);
            }
        }
    };

    /* script */
    var __vue_script__$2 = script$2;

    /* template */
    var __vue_render__$2 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.color,
              expression: "color"
            }
          ],
          ref: "color",
          attrs: { type: "color" },
          domProps: { value: _vm.color },
          on: {
            click: _vm.focus,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.color = $event.target.value;
            }
          }
        }),
        _vm._v(" "),
        _c("button", { attrs: { type: "button" }, on: { click: _vm.setcolor } }, [
          _vm._v("Set")
        ])
      ])
    };
    var __vue_staticRenderFns__$2 = [];
    __vue_render__$2._withStripped = true;

      /* style */
      var __vue_inject_styles__$2 = undefined;
      /* scoped */
      var __vue_scope_id__$2 = undefined;
      /* module identifier */
      var __vue_module_identifier__$2 = undefined;
      /* functional template */
      var __vue_is_functional_template__$2 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var fontcolor = normalizeComponent_1(
        { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
        __vue_inject_styles__$2,
        __vue_script__$2,
        __vue_scope_id__$2,
        __vue_is_functional_template__$2,
        __vue_module_identifier__$2,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //


    var script$3 = {
        title: "Background color",
        description: "Font background color",
        icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata><g><g transform="translate(0.000000,430.000000) scale(0.100000,-0.100000)"><path d="M4201.63551.8c-32-20-85.9-65.9-117.8-99.8c-53.9-55.9-71.9-61.9-171.7-61.9c-325.5,0-938.6-71.9-1306-151.8c-794.8-173.7-1387.9-531.2-1587.6-956.5c-85.9-179.7-107.8-279.6-107.8-479.3c2-337.5,125.8-643,361.4-882.6L1405.9,784L822.8,194.9c-527.2-533.2-589.1-603.1-649-728.9c-53.9-117.8-65.9-167.7-71.9-321.5c-10-199.7,18-319.5,111.8-487.2c32-57.9,671-710.9,1749.3-1789.3c1557.6-1557.6,1709.4-1705.4,1829.2-1763.3c255.6-123.8,523.2-123.8,778.8,0c117.8,57.9,279.6,213.7,1837.2,1767.3c940.6,938.6,1719.4,1705.4,1731.3,1705.4c35.9,0,157.7-157.8,223.7-293.6c107.8-217.7,195.7-583.1,231.6-964.5c6-71.9,20-367.4,30-659c20-581.1,49.9-792.8,137.8-988.5c91.9-201.7,247.6-283.6,413.3-219.7c385.4,147.8,677,1238.1,720.9,2695.9c30,1030.4-155.8,1805.2-585.1,2450.2c-145.8,217.7-407.4,505.2-609.1,667C8077.7,1764.5,7193,2058.1,6228.5,2086l-329.5,10l-728.9,724.9c-401.4,399.4-748.9,734.9-772.8,746.9C4333.4,3599.7,4269.5,3593.7,4201.6,3551.8z M6254.5,1157.5l1931-1931L6324.4-2634.7c-1445.8-1443.8-1883.1-1871.1-1953-1901.1c-115.8-51.9-263.6-51.9-379.4,0c-69.9,30-463.3,413.4-1751.3,1701.4C1328-1919.8,565.2-1143,547.2-1105.1c-18,36-37.9,113.8-43.9,169.7c-20,197.7,10,237.7,661,888.7l585.1,585.1l197.7-93.9C2538.2,167,3364.9-10.7,4305.5-62.7l323.5-18l55.9-63.9c181.7-217.7,543.2-169.7,680.9,89.9c65.9,129.8,20,375.4-87.9,471.3c-165.7,145.8-411.4,139.8-569.1-14l-75.9-73.9l-245.6,14c-718.9,39.9-1399.8,157.8-1893.1,327.5c-193.7,65.9-419.4,163.8-419.4,181.7c0,14,2222.6,2238.6,2236.6,2238.6C4317.4,3090.5,5190.1,2221.8,6254.5,1157.5z M2646,2014.2l-936.6-936.6l-59.9,41.9c-87.9,65.9-225.7,259.6-275.6,389.4c-67.9,173.7-65.9,415.4,6,567.1c193.7,413.4,834.7,714.9,1793.2,842.7c115.8,16,253.6,27.9,309.5,30l99.8,2L2646,2014.2z M6971.4,1590.8c1563.6-317.5,2428.3-1316,2508.1-2895.6c35.9-726.9-47.9-1657.5-205.7-2260.5c-53.9-207.7-149.8-473.3-171.7-473.3c-32,0-75.9,523.2-77.9,908.6c0,427.3-59.9,898.6-151.8,1228.1c-65.9,235.6-223.7,545.2-345.5,680.9l-99.8,111.8l89.9,87.9c111.8,107.8,147.8,173.7,147.8,271.6c0,71.9-37.9,113.8-1172.2,1250.1L6318.4,1676.7l179.7-12C6597.9,1656.7,6809.6,1624.8,6971.4,1590.8z"/></g></g></svg>',
        data: function data()
        {
            return {
                color: '#000000'
            }
        },
        created: function created()
        {
            var this$1 = this;

            this.$nextTick(function () {
                this$1.$refs.color.focus();        });        
        },
        methods:
        {
            focus: function focus()
            {
                this.$refs.color.focus();
            },
            setcolor: function setcolor(e)
            {
                this.$parent.closeDashboard();
                this.$emit("exec", "hiliteColor", this.color);
            }
        }
    };

    /* script */
    var __vue_script__$3 = script$3;

    /* template */
    var __vue_render__$3 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.color,
              expression: "color"
            }
          ],
          ref: "color",
          attrs: { type: "color" },
          domProps: { value: _vm.color },
          on: {
            click: _vm.focus,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.color = $event.target.value;
            }
          }
        }),
        _vm._v(" "),
        _c("button", { attrs: { type: "button" }, on: { click: _vm.setcolor } }, [
          _vm._v("Set")
        ])
      ])
    };
    var __vue_staticRenderFns__$3 = [];
    __vue_render__$3._withStripped = true;

      /* style */
      var __vue_inject_styles__$3 = undefined;
      /* scoped */
      var __vue_scope_id__$3 = undefined;
      /* module identifier */
      var __vue_module_identifier__$3 = undefined;
      /* functional template */
      var __vue_is_functional_template__$3 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var backgroundcolor = normalizeComponent_1(
        { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
        __vue_inject_styles__$3,
        __vue_script__$3,
        __vue_scope_id__$3,
        __vue_is_functional_template__$3,
        __vue_module_identifier__$3,
        undefined,
        undefined
      );

    var alignLeft = {
    	title: "justifyLeft",
    	action: ["justifyLeft"],
        description: "Justify Left",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/></svg>'
    };

    var alignCenter = {
    	title: "justifyCenter",
    	action: ["justifyCenter"],
        description: "Center",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/></svg>'
    };

    var alignRight = {
    	title: "justifyRight",
    	action: ["justifyRight"],
        description: "Justify Right",
    	icon: '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/></svg>'
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$4 = {
        title: "headings",
        description: "Headings (h1-h6)",
        icon: '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1682 1664q-44 0-132.5-3.5t-133.5-3.5q-44 0-132 3.5t-132 3.5q-24 0-37-20.5t-13-45.5q0-31 17-46t39-17 51-7 45-15q33-21 33-140l-1-391q0-21-1-31-13-4-50-4h-675q-38 0-51 4-1 10-1 31l-1 371q0 142 37 164 16 10 48 13t57 3.5 45 15 20 45.5q0 26-12.5 48t-36.5 22q-47 0-139.5-3.5t-138.5-3.5q-43 0-128 3.5t-127 3.5q-23 0-35.5-21t-12.5-45q0-30 15.5-45t36-17.5 47.5-7.5 42-15q33-23 33-143l-1-57v-813q0-3 .5-26t0-36.5-1.5-38.5-3.5-42-6.5-36.5-11-31.5-16-18q-15-10-45-12t-53-2-41-14-18-45q0-26 12-48t36-22q46 0 138.5 3.5t138.5 3.5q42 0 126.5-3.5t126.5-3.5q25 0 37.5 22t12.5 48q0 30-17 43.5t-38.5 14.5-49.5 4-43 13q-35 21-35 160l1 320q0 21 1 32 13 3 39 3h699q25 0 38-3 1-11 1-32l1-320q0-139-35-160-18-11-58.5-12.5t-66-13-25.5-49.5q0-26 12.5-48t37.5-22q44 0 132 3.5t132 3.5q43 0 129-3.5t129-3.5q25 0 37.5 22t12.5 48q0 30-17.5 44t-40 14.5-51.5 3-44 12.5q-35 23-35 161l1 943q0 119 34 140 16 10 46 13.5t53.5 4.5 41.5 15.5 18 44.5q0 26-12 48t-36 22z"/></svg>',

        methods: {
            insertHeading: function insertHeading(e){
                this.$parent.closeDashboard();
                this.$emit("exec", "formatBlock", e.target.textContent);
            }
        }
    };

    /* script */
    var __vue_script__$4 = script$4;

    /* template */
    var __vue_render__$4 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", [
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H1")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H2")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H3")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H4")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H5")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.insertHeading } },
          [_vm._v("H6")]
        )
      ])
    };
    var __vue_staticRenderFns__$4 = [];
    __vue_render__$4._withStripped = true;

      /* style */
      var __vue_inject_styles__$4 = undefined;
      /* scoped */
      var __vue_scope_id__$4 = undefined;
      /* module identifier */
      var __vue_module_identifier__$4 = undefined;
      /* functional template */
      var __vue_is_functional_template__$4 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var headings = normalizeComponent_1(
        { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
        __vue_inject_styles__$4,
        __vue_script__$4,
        __vue_scope_id__$4,
        __vue_is_functional_template__$4,
        __vue_module_identifier__$4,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    var script$5 = {
        title: "link",
        icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/></svg>',
        description: "Hyperlink",
        props: {
          uid: null
        },

        data: function data(){
            return {
                url: "",
                title: "",
            }
        },
        methods: {
            insertLink: function insertLink(){
                this.$emit("exec", "insertHTML", ("<a href='" + (this.url) + "' title='" + (this.title) + "'>" + (this.$parent.$parent.selHtml) + "</a>"));
                this.$parent.closeDashboard();
                this.url = "";
                this.title = "";
            }
        }
    };

    /* script */
    var __vue_script__$5 = script$5;

    /* template */
    var __vue_render__$5 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault();
              return _vm.insertLink($event)
            }
          }
        },
        [
          _c("label", [
            _vm._v("\n        URL\n        "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.url,
                  expression: "url"
                }
              ],
              ref: "url",
              staticStyle: { width: "40%" },
              attrs: { type: "text" },
              domProps: { value: _vm.url },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.url = $event.target.value;
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("label", [
            _vm._v("\n        Link Title\n        "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticStyle: { width: "40%" },
              attrs: { type: "text" },
              domProps: { value: _vm.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.title = $event.target.value;
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("button", { attrs: { type: "submit" } }, [_vm._v("Insert")])
        ]
      )
    };
    var __vue_staticRenderFns__$5 = [];
    __vue_render__$5._withStripped = true;

      /* style */
      var __vue_inject_styles__$5 = undefined;
      /* scoped */
      var __vue_scope_id__$5 = undefined;
      /* module identifier */
      var __vue_module_identifier__$5 = undefined;
      /* functional template */
      var __vue_is_functional_template__$5 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var hyperlink = normalizeComponent_1(
        { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
        __vue_inject_styles__$5,
        __vue_script__$5,
        __vue_scope_id__$5,
        __vue_is_functional_template__$5,
        __vue_module_identifier__$5,
        undefined,
        undefined
      );

    var file = {
    	title: "fileUpload",
    	action: ["fileUpload"],
    	description: "Upload files",
    	icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"-23 0 512 512.00072\">\n    <g id=\"surface1\">\n    <path d=\"M 348.945312 221.640625 L 348.945312 124.746094 C 348.945312 121.972656 347.664062 119.410156 345.851562 117.382812 L 237.21875 3.308594 C 235.191406 1.175781 232.308594 0 229.429688 0 L 57.195312 0 C 25.398438 0 0 25.929688 0 57.730469 L 0 383.414062 C 0 415.214844 25.398438 440.71875 57.195312 440.71875 L 193.148438 440.71875 C 218.863281 483.402344 265.605469 512 318.851562 512 C 399.738281 512 465.792969 446.265625 465.792969 365.273438 C 465.902344 294.523438 415.105469 235.40625 348.945312 221.640625 Z M 240.101562 37.457031 L 312.984375 114.179688 L 265.710938 114.179688 C 251.625 114.179688 240.101562 102.550781 240.101562 88.464844 Z M 57.195312 419.375 C 37.242188 419.375 21.34375 403.367188 21.34375 383.414062 L 21.34375 57.730469 C 21.34375 37.667969 37.242188 21.34375 57.195312 21.34375 L 218.757812 21.34375 L 218.757812 88.464844 C 218.757812 114.394531 239.78125 135.523438 265.710938 135.523438 L 327.601562 135.523438 L 327.601562 218.863281 C 324.402344 218.757812 321.839844 218.4375 319.066406 218.4375 C 281.824219 218.4375 247.570312 232.738281 221.746094 255.148438 L 86.222656 255.148438 C 80.351562 255.148438 75.550781 259.949219 75.550781 265.816406 C 75.550781 271.6875 80.351562 276.488281 86.222656 276.488281 L 201.898438 276.488281 C 194.320312 287.160156 188.023438 297.832031 183.117188 309.570312 L 86.222656 309.570312 C 80.351562 309.570312 75.550781 314.371094 75.550781 320.242188 C 75.550781 326.109375 80.351562 330.914062 86.222656 330.914062 L 176.179688 330.914062 C 173.511719 341.585938 172.125 353.429688 172.125 365.273438 C 172.125 384.480469 175.859375 403.476562 182.582031 419.484375 L 57.195312 419.484375 Z M 318.960938 490.765625 C 249.8125 490.765625 193.574219 434.527344 193.574219 365.378906 C 193.574219 296.230469 249.703125 239.992188 318.960938 239.992188 C 388.214844 239.992188 444.34375 296.230469 444.34375 365.378906 C 444.34375 434.527344 388.109375 490.765625 318.960938 490.765625 Z M 318.960938 490.765625 \" style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" />\n    <path d=\"M 86.222656 223.027344 L 194.320312 223.027344 C 200.191406 223.027344 204.992188 218.222656 204.992188 212.355469 C 204.992188 206.484375 200.191406 201.683594 194.320312 201.683594 L 86.222656 201.683594 C 80.351562 201.683594 75.550781 206.484375 75.550781 212.355469 C 75.550781 218.222656 80.351562 223.027344 86.222656 223.027344 Z M 86.222656 223.027344 \" style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" />\n    <path d=\"M 326.535156 286.625 C 324.507812 284.492188 321.734375 283.210938 318.746094 283.210938 C 315.757812 283.210938 312.984375 284.492188 310.957031 286.625 L 248.421875 353.746094 C 244.367188 358.015625 244.6875 364.84375 248.957031 368.792969 C 253.226562 372.847656 260.160156 372.527344 264.214844 368.261719 L 308.394531 320.988281 L 308.394531 437.515625 C 308.394531 443.386719 313.195312 448.1875 319.066406 448.1875 C 324.933594 448.1875 329.738281 443.386719 329.738281 437.515625 L 329.738281 320.988281 L 373.59375 368.261719 C 375.730469 370.5 378.503906 371.675781 381.386719 371.675781 C 383.945312 371.675781 386.507812 370.714844 388.640625 368.792969 C 392.910156 364.738281 393.230469 358.015625 389.175781 353.746094 Z M 326.535156 286.625 \" style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" />\n    </g>\n    </svg>"
    };

    var code = {
        title: "code",
        icon: '<svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg"><path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/></svg>',
        description: "Code",
        action: ["formatBlock", "pre"]
    };

    var list_ordered = {
    	title: "orderedList",
    	action: ["insertOrderedList"],
      description: "Ordered List (1, 2, 3)",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/></svg>'
    };

    var list_unordered = {
    	title: "unorderedList",
    	action: ["insertUnorderedList"],
      description: "Bullet List",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/></svg>'
    };

    //

    var UPLOAD_ICON = '<svg fill="#666" width="26" height="24" viewBox="0 0 2048 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1344 864q0-14-9-23l-352-352q-9-9-23-9t-23 9l-351 351q-10 12-10 24 0 14 9 23t23 9h224v352q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5v-352h224q13 0 22.5-9.5t9.5-22.5zm640 288q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"/></svg>';

    var script$6 = {
        title: "image",
        icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/></svg>',
        description: "Insert Image",

        props: ["options"],
        components: {
            Dropzone: Dropzone
        },

        computed: {
            uploadURL: function uploadURL () {
                return this.options.image.uploadURL;
            },

            dropzoneOptions: function dropzoneOptions () {
              return Object.assign({}, this.options.image.dropzoneOptions,

                // vue2-dropzone config
                {id: ((this._uid) + "vwdropzone"),
                url: this.uploadURL,
                autoProcessQueue: this.uploadURL !== 'None',
                dictDefaultMessage: ("<i class=\"fa\">" + UPLOAD_ICON + "</i><br>Click here to upload...")})
            }
        },

        methods: {
            fileUploaded: function fileUploaded (file, r) {
                if (r)
                    { this.$emit("exec", "insertHTML", ("<img src=" + r + ">")); }
            },

            fileAdded: function fileAdded (file) {
                var this$1 = this;

                // if no upload url is defined, insert image with base64 src
                if (file && this.uploadURL !== "None")
                    { return; }

                var reader = new FileReader();

                reader.addEventListener("load", function () {
                   this$1.$emit("exec", "insertHTML", ("<img src=" + (reader.result) + ">"));
                }, false);

                reader.readAsDataURL(file);
            }
        },
    };

    /* script */
    var __vue_script__$6 = script$6;

    /* template */
    var __vue_render__$6 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("Dropzone", {
        ref: "dropzone",
        attrs: { options: _vm.dropzoneOptions, id: _vm._uid + "vwdropzone" },
        on: {
          "vdropzone-success": _vm.fileUploaded,
          "vdropzone-file-added": _vm.fileAdded
        }
      })
    };
    var __vue_staticRenderFns__$6 = [];
    __vue_render__$6._withStripped = true;

      /* style */
      var __vue_inject_styles__$6 = undefined;
      /* scoped */
      var __vue_scope_id__$6 = undefined;
      /* module identifier */
      var __vue_module_identifier__$6 = undefined;
      /* functional template */
      var __vue_is_functional_template__$6 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var image = normalizeComponent_1(
        { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
        __vue_inject_styles__$6,
        __vue_script__$6,
        __vue_scope_id__$6,
        __vue_is_functional_template__$6,
        __vue_module_identifier__$6,
        undefined,
        undefined
      );

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    var script$7 = {
        title: "table",
        description: "Insert Table",
        icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/></svg>',

        data: function data()
        {
            return {
                rows: 2,
                cols: 2
            }
        },
        methods:
        {
            focusOne: function focusOne()
            {
                this.$refs.fone.focus();
            },
            focusTwo: function focusTwo()
            {
                this.$refs.ftwo.focus();
            },
            insertTable: function insertTable()
            {
                var rows = (
                    "<tr>" + "<td></td>".repeat(this.cols) + "</tr>"
                ).repeat(this.rows);

                this.$emit("exec", "insertHTML", ("<table><tbody>" + rows + "</tbody></table>"));
                this.$parent.closeDashboard();

            }
        }
    };

    /* script */
    var __vue_script__$7 = script$7;

    /* template */
    var __vue_render__$7 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c(
        "form",
        {
          staticClass: "lb-vue-wysiwyg-form",
          on: {
            submit: function($event) {
              $event.preventDefault();
              return _vm.insertTable($event)
            }
          }
        },
        [
          _c("div", [
            _c("label", [_vm._v("Rows")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rows,
                  expression: "rows"
                }
              ],
              ref: "fone",
              staticStyle: { width: "60px" },
              attrs: { type: "number", min: "1" },
              domProps: { value: _vm.rows },
              on: {
                click: _vm.focusOne,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.rows = $event.target.value;
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [_vm._v("Columns")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cols,
                  expression: "cols"
                }
              ],
              ref: "ftwo",
              staticStyle: { width: "60px" },
              attrs: { type: "number", min: "1" },
              domProps: { value: _vm.cols },
              on: {
                click: _vm.focusTwo,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.cols = $event.target.value;
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("button", { attrs: { type: "submit" } }, [_vm._v("Insert")])
        ]
      )
    };
    var __vue_staticRenderFns__$7 = [];
    __vue_render__$7._withStripped = true;

      /* style */
      var __vue_inject_styles__$7 = undefined;
      /* scoped */
      var __vue_scope_id__$7 = undefined;
      /* module identifier */
      var __vue_module_identifier__$7 = undefined;
      /* functional template */
      var __vue_is_functional_template__$7 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var table = normalizeComponent_1(
        { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
        __vue_inject_styles__$7,
        __vue_script__$7,
        __vue_scope_id__$7,
        __vue_is_functional_template__$7,
        __vue_module_identifier__$7,
        undefined,
        undefined
      );

    var removeFormat = {
    	title: "removeFormat",
    	action: ["removeFormat"],
    	description: "Remove formatting.\nClears headings, bold, italic, underlined text, etc.",
    	icon: '<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/></svg>'
    };

    var removeStyles = {
    	title: "removeStyles",
    	action: ["removeStyles"],
    	description: "Remove styles",
    	icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><g><g transform="matrix(1 0 0 -1 0 1008)"><path d="M990,385.5L832.5,228L990,70.5L937.5,18L780,175.5L622.5,18L570,70.5L727.5,228L570,385.5l52.5,52.5L780,280.5L937.5,438L990,385.5z M875.3,998L850,928H572.9L343.5,298h-74.9l229.4,630H220l25.3,70H875.3z M10,158l25.3,70h525L535,158H10z"/></g></g></svg>'
    };

    var removeHtmlTags = {
    	title: "removeHtmlTags",
    	action: ["removeHtmlTags"],
    	description: "Remove html tags",
    	icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M 8.4375 1 C 8.0355 1 7.6560938 1.1563594 7.3710938 1.4433594 L 1.4355469 7.4277344 C 0.85554688 8.0107344 0.85745312 8.9619219 1.4394531 9.5449219 L 5.4550781 13.560547 C 5.7480781 13.852547 6.1325781 13.998047 6.5175781 13.998047 C 6.8995781 13.998047 7.2822187 13.853453 7.5742188 13.564453 L 9.1621094 11.988281 L 8.453125 11.28125 L 6.8671875 12.855469 C 6.6741875 13.047469 6.3571094 13.047516 6.1621094 12.853516 L 2.1464844 8.8378906 C 1.9534844 8.6428906 1.9515312 8.3278125 2.1445312 8.1328125 L 8.0820312 2.1484375 C 8.1770312 2.0524375 8.3035 2 8.4375 2 L 12.5 2 C 12.775 2 13 2.224 13 2.5 L 13 6.5625 C 13 6.6945 12.944563 6.8249688 12.851562 6.9179688 L 11.292969 8.4648438 L 12 9.171875 L 13.556641 7.6269531 C 13.838641 7.3459531 14 6.9575 14 6.5625 L 14 2.5 C 14 1.673 13.327 1 12.5 1 L 8.4375 1 z M 11.5 3 A 0.5 0.5 0 0 0 11 3.5 A 0.5 0.5 0 0 0 11.5 4 A 0.5 0.5 0 0 0 12 3.5 A 0.5 0.5 0 0 0 11.5 3 z M 9.8535156 9.1464844 L 9.1464844 9.8535156 L 11.792969 12.5 L 9.1464844 15.146484 L 9.8535156 15.853516 L 12.5 13.207031 L 15.146484 15.853516 L 15.853516 15.146484 L 13.207031 12.5 L 15.853516 9.8535156 L 15.146484 9.1464844 L 12.5 11.792969 L 9.8535156 9.1464844 z"/></svg>'
    };

    var viewSource = {
    	title: "viewSource",
    	action: ["viewSource"],
    	description: "View source of the document",
    	icon: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><g><g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"><path d="M303.8,4222.5c-83.5-37.4-156.1-125.3-184.6-230.8c-17.6-54.9-22-1301.2-17.6-3936.5l6.6-3857.4l50.5-79.1C259.8-4046.2-173.1-4033,5014-4033c4606.9,0,4655.2,0,4727.8,44c39.6,24.2,90.1,74.7,114.3,114.3c44,72.5,44,118.7,44,3973.9c0,3734.3-2.2,3905.7-39.6,3978.3c-26.4,48.4-76.9,96.7-136.3,127.5l-96.7,48.4H4998.6C1176.4,4251,360.9,4246.7,303.8,4222.5z M6251.4,3523.5c105.5-55,197.8-195.6,197.8-303.3c0-30.8-22-101.1-48.4-153.9c-96.7-191.2-342.9-250.6-509.9-125.3c-213.2,162.7-180.2,479.2,61.5,589.1C6071.2,3582.9,6132.7,3582.9,6251.4,3523.5z M7469.1,3527.9c263.7-127.5,261.5-490.1,0-617.6c-356.1-171.4-670.4,294.5-378,567.1C7198.7,3578.5,7330.6,3596.1,7469.1,3527.9z M8732.9,3512.5c211-158.2,208.8-428.6-4.4-586.8c-46.2-33-94.5-46.2-180.2-46.2c-131.9,0-208.8,44-290.1,164.8c-114.3,167.1-28.6,422,169.3,503.3C8506.5,3580.7,8664.7,3563.1,8732.9,3512.5z M9236.2-553.7l-6.6-2809l-4224.4-6.6l-4226.6-4.4v2813.4v2813.4h4231h4231L9236.2-553.7z"/><path d="M1943.5,1264c-39.6-39.6-44-72.5-44-380.2c0-250.6,6.6-345.1,30.8-378.1c17.6-24.2,244-211,505.5-417.6c259.4-204.4,472.6-378,472.6-384.6s-197.8-169.2-441.8-362.7c-241.8-193.4-468.2-378.1-503.3-411l-63.7-57.1v-342.9c0-340.7,0-345.1,57.1-400c33-35.2,70.3-52.8,96.7-46.2c61.5,15.4,1797.9,1241.8,1835.3,1296.8c50.5,72.5,46.2,586.9-4.4,650.6c-68.1,81.3-1795.7,1274.8-1846.3,1277C2009.4,1308,1967.6,1288.2,1943.5,1264z"/><path d="M3835.9-1760.3c-65.9-54.9-68.1-61.6-68.1-252.8c0-180.2,4.4-202.2,54.9-250.6l52.7-54.9h1211.1h1211.1l52.8,54.9c50.5,48.4,54.9,70.3,54.9,250.6c0,191.2-2.2,197.8-68.1,252.8l-68.1,57.1H5086.5H3904L3835.9-1760.3z"/></g></g></svg>'
    };

    var separator = {
    	title: "separator",
    	icon: "<i class='vw-separator'></i>"
    };

    function styleInject(css, ref) {
      if ( ref === void 0 ) { ref = {}; }
      var insertAt = ref.insertAt;

      if (!css || typeof document === 'undefined') { return; }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css = ".editr {\n  border: 1px solid #e3e3e3;\n  width: 100%; }\n\n.editr pre[class*=\"language-\"] {\n  margin: 0px; }\n\n.editr--toolbar {\n  background: #f6f6f6;\n  border-bottom: 1px solid #e3e3e3;\n  position: relative;\n  display: flex;\n  height: 32px; }\n  .editr--toolbar a {\n    display: inline-block;\n    width: 8vw;\n    max-width: 32px;\n    height: 32px;\n    color: #333;\n    fill: #333;\n    cursor: pointer;\n    text-align: center;\n    line-height: 1; }\n    .editr--toolbar a:hover {\n      background: rgba(0, 0, 0, 0.1); }\n    .editr--toolbar a:active {\n      background: rgba(0, 0, 0, 0.2); }\n    .editr--toolbar a svg {\n      width: 16px;\n      height: 16px;\n      margin: 8px auto; }\n      .editr--toolbar a svg path {\n        fill: inherit; }\n    .editr--toolbar a.vw-btn-separator {\n      width: 1px;\n      margin: 0 8px; }\n      .editr--toolbar a.vw-btn-separator:hover {\n        background: initial;\n        cursor: default; }\n      .editr--toolbar a.vw-btn-separator i.vw-separator {\n        border-left: 1px solid rgba(0, 0, 0, 0.1);\n        height: 100%;\n        position: absolute;\n        width: 1px; }\n  .editr--toolbar .dashboard {\n    width: 100%;\n    position: absolute;\n    top: 32px;\n    left: 0;\n    text-align: left;\n    padding: 8px 16px;\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid #f6f6f6; }\n\n.editr--content {\n  min-height: 150px;\n  padding: 12px 8px 16px 8px;\n  line-height: 1.33;\n  font-family: inherit;\n  color: inherit;\n  overflow-y: auto; }\n  .editr--content[contenteditable=true]:empty:before {\n    content: attr(placeholder);\n    color: rgba(0, 0, 0, 0.3);\n    display: block;\n    /* For Firefox */ }\n  .editr--content img {\n    max-width: 100%; }\n  .editr--content table {\n    width: 100%;\n    border-collapse: collapse; }\n    .editr--content table th {\n      text-align: left; }\n    .editr--content table th, .editr--content table td {\n      border: 1px solid #dddddd;\n      padding: 2px; }\n  .editr--content:focus {\n    outline: 0; }\n  .editr--content ul li, .editr--content ol li {\n    list-style-position: inside; }\n\n@media screen and (max-width: 320px) {\n  .editr--toolbar a {\n    margin: 0 2px; }\n  .editr--toolbar a.vw-btn-separator {\n    display: none; } }\n\n.lb-vue-wysiwyg-form {\n  display: flex;\n  align-content: flex-end; }\n  .lb-vue-wysiwyg-form div {\n    margin-right: 1rem; }\n";
    styleInject(css);

    //

    var modules = [
        bold, italic, underline, fontsize, fontcolor, backgroundcolor, separator,
        alignLeft, alignCenter, alignRight, separator,
        headings, hyperlink, file, code,
        list_ordered, list_unordered, separator,
        image, table, separator,
        removeFormat, removeStyles, removeHtmlTags, separator,
        viewSource
    ];

    var script$8 = {
        model:
        {
            prop: "html",
            event: "html"
        },
        props:
        {
            html:
            {
                type: String,
                default: ""
            },
            placeholder:
            {
                type: String,
                default: "Enter text..."
            },
            options:
            {
                type: Object,
                default: function () { return {} }
            },
            translateMethod: null
        },
        components:
        {
            Btn: Btn,
            PrismEditor: PrismEditor
        },
        initOptions: {},
        data: function data()
        {
            return {
                textareaModel: '',
                source: false,
                sourceCode: '',
                selection: "",
                selHtml: ''
            }
        },
        computed:
        {
            mergedOptions: function mergedOptions()
            {
                return Object.assign({}, {image:
                    {
                        uploadURL: "None",
                        dropzoneOptions: {}
                    },
                    hideModules: {},
                    paragraphSeparator: "div",
                    maxHeight: undefined,
                    customModules: []},
                    this.initOptions,
                    this.options)
            },
            modules: function modules$1()
            {
                var this$1 = this;

                var customIcons = this.mergedOptions.iconOverrides;

                return modules
                    .filter(
                        function (m) { return this$1.mergedOptions.hideModules === undefined ||
                        !this$1.mergedOptions.hideModules[m.title]; }
                    )
                    .map(function (mod) {
                        if (customIcons !== undefined && customIcons[mod.title] !== undefined)
                        {
                            mod.icon = customIcons[mod.title];
                        }
                        return mod;
                    })
                    .concat(this.mergedOptions.customModules);
            },
            btnsWithDashboards: function btnsWithDashboards()
            {
                if (this.modules)
                    { return this.modules.filter(function (m) { return m.render; }); }
                return [];
            },
            innerHTML:
            {
                get: function get()
                {
                    if (this.$refs.content) { return this.$refs.content.innerHTML; }
                    return '';
                },

                set: function set(html)
                {
                    if (this.$refs.content.innerHTML !== html)
                    {
                        this.$refs.content.innerHTML = html;
                    }
                }
            }
        },
        methods:
        {
            translate: function translate(key)
            {
                var me = this;
                if (me.translateMethod != null)
                {
                    return me.translateMethod(key);
                }
                return key;
            },
            getSelectionHtml: function getSelectionHtml()
            {
                var html = "";
                if (typeof window.getSelection != "undefined") {
                    var sel = window.getSelection();
                    var container = document.createElement("div");
                    container.appendChild(sel.getRangeAt(0).cloneContents());
                    html = container.innerHTML;
                } else if (typeof document.selection != "undefined") {
                    if (document.selection.type == "Text") {
                        html = document.selection.createRange().htmlText;
                    }
                }

                return html;
            },
            saveSelection: function saveSelection()
            {
                if (window.getSelection !== undefined)
                {
                    this.selection = window.getSelection();
                    if (this.selection.getRangeAt && this.selection.rangeCount)
                    {
                        return this.selection.getRangeAt(0);
                    }
                }
                else if (document.selection && document.selection.createRange)
                {
                    return document.selection.createRange();
                }
                return null;
            },
            restoreSelection: function restoreSelection(range)
            {
                if (range)
                {
                    if (window.getSelection !== undefined)
                    {
                        this.selection = window.getSelection();
                        this.selection.removeAllRanges();
                        this.selection.addRange(range);
                    }
                    else if (document.selection && range.select)
                        { range.select(); }
                }
            },
            clearSelection: function clearSelection()
            {
                this.selection = null;
                var selection = window.getSelection();

                if (selection)
                {
                    if (selection.empty !== undefined)
                    {
                        selection.empty();
                    }
                    if (selection.removeAllRanges !== undefined)
                    {
                        selection.removeAllRanges();
                    }
                }
            },
            exec: function exec(cmd, arg, sel)
            {
                var me = this;
                if (cmd == 'viewSource')
                {
                    this.textareaModel = this.$refs.content.innerHTML;
                    if (me.source == true)
                    {
                        this.$refs.content.innerHTML = me.sourceCode;
                        this.emit();
                        me.$nextTick(function () {
                            me.source = false;
                        });
                    }
                    else
                    {
                        me.source = true;
                    }
                }
                if (cmd == 'fileUpload')
                {
                    if (this.mergedOptions.fileUpload !== undefined)
                    {
                        this.mergedOptions.fileUpload(this);
                    }
                }
                else if (cmd == 'removeFormat')
                {
                    if (document.selection)
                    {
                        var range = document.body.createTextRange();
                        range.moveToElementText(this.$refs.content);
                        range.select();
                    }
                    else if (window.getSelection)
                    {
                        window.getSelection().removeAllRanges();
                        var range = document.createRange();
                        range.selectNodeContents(this.$refs.content);
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(range);
                    }

                    sel !== false && this.selection && this.restoreSelection(this.selection);
                    document.execCommand(cmd, false, arg || "");
                    this.clearSelection();
                    this.$nextTick(this.emit);
                }
                else if (cmd == 'removeStyles')
                {
                    var myString = this.$refs.content.innerHTML;
                    myString = myString.replace(/(<[^>]+) style=".*?"/ig, '$1');
                    myString = myString.replace(/(<[^>]+) class=".*?"/ig, '$1');
                    this.$refs.content.innerHTML = myString;
                    this.emit();
                }
                else if (cmd == 'removeHtmlTags')
                {
                    var myString = this.$refs.content.innerHTML;
                    myString = myString.replace(/<\/?[^>]+(>|$)/g, "");
                    this.$refs.content.innerHTML = myString;
                    this.emit();
                }
                else
                {
                    sel !== false && this.selection && this.restoreSelection(this.selection);
                    document.execCommand(cmd, false, arg || "");
                    this.clearSelection();
                    this.$nextTick(this.emit);
                }
            },
            onDocumentClick: function onDocumentClick(e)
            {
                for (var i = 0; i < this.btnsWithDashboards.length; i++)
                {
                    var btn = this.$refs[("btn-" + (this.btnsWithDashboards[i].title))][0];
                    if (btn && btn.showDashboard && !btn.$el.contains(e.target))
                        { btn.closeDashboard(); }
                }
            },
            emit: function emit()
            {
                if (this.source) { this.textareaModel = this.$refs.content.innerHTML; }
                this.$emit("html", this.$refs.content.innerHTML);
                this.$emit("change", this.$refs.content.innerHTML);
            },
            onInput: debounce(function()
            {
                this.emit();
            }, 300),
            onFocus: function onFocus()
            {
                document.execCommand("defaultParagraphSeparator", false, this.mergedOptions.paragraphSeparator);
            },
            onMouseUp: function onMouseUp()
            {
                // save focus to restore it later
                this.selHtml = this.getSelectionHtml();
                this.selection = this.saveSelection();
                this.$emit("blur", this.$refs.content);
            },
            onPaste: function onPaste(e)
            {
                e.preventDefault();

                // get a plain representation of the clipboard
                var text = e.clipboardData.getData("text/plain");

                // insert that plain text text manually
                document.execCommand("insertHTML", false, text);
            },
            syncHTML: function syncHTML()
            {
                if (this.html !== this.$refs.content.innerHTML)
                    { this.innerHTML = this.html; }
            },
            setCode: function setCode(val)
            {
                this.sourceCode = val;
            }
        },
        mounted: function mounted()
        {
            this.unwatch = this.$watch("html", this.syncHTML,
            {
                immediate: true
            });

            document.addEventListener("click", this.onDocumentClick);

            this.$refs.content.addEventListener("focus", this.onFocus);
            this.$refs.content.addEventListener("input", this.onInput);
            this.$refs.content.addEventListener("mouseup", this.onMouseUp,
            {
                capture: true
            });

            if (this.mergedOptions.forcePlainTextOnPaste === true)
            {
                this.$refs.content.addEventListener("paste", this.onPaste);
            }

            this.$refs.content.style.maxHeight = this.mergedOptions.maxHeight;
        },
        beforeDestroy: function beforeDestroy()
        {
            this.unwatch();
            document.removeEventListener("click", this.onDocumentClick);

            this.$refs.content.removeEventListener("mouseup", this.onMouseUp);
            this.$refs.content.removeEventListener("input", this.onInput);
            this.$refs.content.removeEventListener("focus", this.onFocus);
        },
        watch:
        {
            textareaModel: function textareaModel(val)
            {
                this.sourceCode = val;
                this.$refs.content.innerHTML = val;
                this.emit();
            }
        }
    };

    /* script */
    var __vue_script__$8 = script$8;

    /* template */
    var __vue_render__$8 = function() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c(
        "div",
        { staticClass: "editr" },
        [
          _c(
            "div",
            { staticClass: "editr--toolbar" },
            _vm._l(_vm.modules, function(module, i) {
              return _c("Btn", {
                key: module.title + i,
                ref: "btn-" + module.title,
                refInFor: true,
                attrs: {
                  module: module,
                  options: _vm.mergedOptions,
                  title: _vm.translate(module.description) || ""
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.source,
                expression: "!source"
              }
            ],
            ref: "content",
            staticClass: "editr--content",
            attrs: {
              contenteditable: "true",
              tabindex: "1",
              placeholder: _vm.placeholder
            }
          }),
          _vm._v(" "),
          _c("PrismEditor", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.source,
                expression: "source"
              }
            ],
            attrs: { code: _vm.textareaModel, language: "html" },
            on: { change: _vm.setCode }
          })
        ],
        1
      )
    };
    var __vue_staticRenderFns__$8 = [];
    __vue_render__$8._withStripped = true;

      /* style */
      var __vue_inject_styles__$8 = undefined;
      /* scoped */
      var __vue_scope_id__$8 = undefined;
      /* module identifier */
      var __vue_module_identifier__$8 = undefined;
      /* functional template */
      var __vue_is_functional_template__$8 = false;
      /* style inject */
      
      /* style inject SSR */
      

      
      var Editr = normalizeComponent_1(
        { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
        __vue_inject_styles__$8,
        __vue_script__$8,
        __vue_scope_id__$8,
        __vue_is_functional_template__$8,
        __vue_module_identifier__$8,
        undefined,
        undefined
      );

    var component = {
    	install: function (Vue, options) {
            if ( options === void 0 ) options = {};

            // Apply configuration
            Editr.props.options = {
                type: Object,
                default: function () { return options }
            };
    		Vue.component("wysiwyg", Editr);
    	},

    	component: Editr
    };

    // Import vue component

    exports.default = component;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
